<div *ngIf="writingPostEnabled && currentUser" class="grid justify-content-center grid-nogutter">
  <ng-container>
    <p-card *ngIf="!permissions?.length" [style]="{width: '100%'}" class="col-12 mt-2">
      <button type="button" class="timeline-composer-trigger" (click)="openPostComposer()">
        <app-thumbnail
          classList="thumbnail-inline-block"
          size="md"
          [circle]="true"
          [imgSrc]="currentUser?.avatar | mediaObject">
        </app-thumbnail>
        <span>{{ getComposerLabelKey() | translate }}</span>
      </button>
    </p-card>
    <ng-container *ngIf="permissions?.length">
      <p-card *ngxPermissionsOnly="permissions" [style]="{width: '100%'}" class="col-12 mb-1">
        <button type="button" class="timeline-composer-trigger" (click)="openPostComposer()">
          <app-thumbnail
            classList="thumbnail-inline-block"
            size="md"
            [circle]="true"
            [imgSrc]="currentUser?.avatar | mediaObject">
          </app-thumbnail>
          <span>{{ getComposerLabelKey() | translate }}</span>
        </button>
      </p-card>
    </ng-container>
  </ng-container>
</div>
<div class="grid infinite justify-content-center grid-nogutter mt-1" [class.refresh-lock]="isRefreshing || isViewSwitching" appPullToRefresh
  [pullToRefreshDisabled]="isSwipePreview || !pullToRefreshEnabled"
  #ptr="appPullToRefresh"
  (refresh)="onPullToRefresh(ptr)">
  <div #timelineViewport class="container timeline-container m-0 p-0">
    <ng-container [ngSwitch]="viewType">
      <ng-container *ngSwitchCase="ViewTypeEnum.GRID">
        <div class="timeline-virtual-spacer" [style.height.px]="virtualTopSpacerHeight"></div>
        <div class="timeline-grid-viewport" [style.--timeline-grid-columns]="effectiveGridColumns">
          <div *ngFor="let row of virtualVisibleGridRows; trackBy: trackByVirtualGridRow" class="timeline-grid-row">
            <div *ngFor="let item of row.items; trackBy: trackByVirtualItem"
              class="timeline-grid-item"
              [id]="item.post?.id ? 'item' + item.post.id : null"
              [attr.data-post-id]="item.post?.id || null">
              <app-timeline-tile [fetchDeleted]="fetchDeleted"
                [renderMode]="renderMode"
                [previewMediaEnabled]="previewMediaEnabled"
                [deferGridMedia]="deferGridMedia"
                [post]="item.post"
                [index]="item.index"
                [currentUser]="currentUser"
                [shareTargetProject]="projectVM"
                [shareTargetEvent]="eventAM"
                [viewType]="viewType"
                [gridTileClickAction]="gridTileClickAction"
                [gridViewportDecoderScope]="gridViewportDecoderScope"
                [visibleMediaType]="visibleMediaType"
                [galleryPostSequence$]="galleryPostSequence$ || loadedPosts$"
                [galleryLoadNextPostPage]="galleryLoadNextPostPage || loadNextPageForGallery"
                [galleryHasNextPostPage]="galleryHasNextPostPage || hasNextPageForGallery"
                [galleryPostPageSize]="galleryPostPageSize || 9"
                [galleryPrefetchAtPostIndex]="galleryPrefetchAtPostIndex ?? 5"
                [galleryPosts]="posts"
                (sharedPostCreated)="onSharedPostCreated($event)"
                (shareCountIncremented)="onShareCountIncremented($event)"
                (gridTileOpen)="navigateToList($event)"
                (gridTileVideoIntent)="prewarmGridGalleryVideo($event)"
                (postContextMenuOpen)="openPostContextMenu($event)"
                (commentContextMenuOpen)="openCommentContextMenu($event)"
                (mobileCommentsOpen)="openMobileCommentsSheet($event)"
                (play)="isPlaying = !isPlaying"></app-timeline-tile>
            </div>
          </div>
        </div>
        <div class="timeline-virtual-spacer" [style.height.px]="virtualBottomSpacerHeight"></div>
      </ng-container>

      <ng-container *ngSwitchDefault>
        <div class="timeline-virtual-spacer" [style.height.px]="virtualTopSpacerHeight"></div>
        <div *ngFor="let item of virtualVisibleItems; trackBy: trackByVirtualItem"
          #virtualItemRef
          class="timeline-list-item"
          [attr.data-virtual-key]="item.key"
          [id]="item.post?.id ? 'item' + item.post.id : null"
          [attr.data-post-id]="item.post?.id || null">
          <app-timeline-tile [fetchDeleted]="fetchDeleted"
            [renderMode]="renderMode"
            [previewMediaEnabled]="previewMediaEnabled"
            [deferGridMedia]="deferGridMedia"
            [post]="item.post"
            [index]="item.index"
            [currentUser]="currentUser"
            [shareTargetProject]="projectVM"
            [shareTargetEvent]="eventAM"
            [viewType]="viewType"
            [visibleMediaType]="visibleMediaType"
            [galleryPostSequence$]="galleryPostSequence$ || loadedPosts$"
            [galleryLoadNextPostPage]="galleryLoadNextPostPage || loadNextPageForGallery"
            [galleryHasNextPostPage]="galleryHasNextPostPage || hasNextPageForGallery"
            [galleryPostPageSize]="galleryPostPageSize || 9"
            [galleryPrefetchAtPostIndex]="galleryPrefetchAtPostIndex ?? 5"
            [galleryPosts]="posts"
            (sharedPostCreated)="onSharedPostCreated($event)"
            (shareCountIncremented)="onShareCountIncremented($event)"
            (gridTileOpen)="navigateToList($event)"
            (postContextMenuOpen)="openPostContextMenu($event)"
            (commentContextMenuOpen)="openCommentContextMenu($event)"
            (mobileCommentsOpen)="openMobileCommentsSheet($event)"
            (play)="isPlaying = !isPlaying"></app-timeline-tile>
        </div>
        <div class="timeline-virtual-spacer" [style.height.px]="virtualBottomSpacerHeight"></div>
      </ng-container>
    </ng-container>

    <div #appendSentinel class="timeline-append-sentinel" aria-hidden="true"></div>
  </div>
  <div class="muted-text bottom-msg" *ngIf="!posts.length && noResultsMsg">
    <p>{{noResultsMsg}}</p>
  </div>
  <div class="muted-text bottom-msg" *ngIf="alreadyOnRecentMsg && posts.length && endOfResults">
    <p>{{alreadyOnRecentMsg | translate}}</p>
  </div>
</div>

<app-bottom-sheet
  *ngIf="!isSwipePreview && mobileCommentsSheetMounted && mobileCommentsPost"
  #timelineCommentsBottomSheet
  [backdrop]="true"
  (dismissed)="onMobileCommentsSheetDismissed()"
>
  <div class="px-2 pt-2 mobile-social-sheet-content">
    <app-social-actions
      [currentUser]="currentUser"
      [post]="mobileCommentsPost"
      [shareTargetProject]="projectVM"
      [shareTargetEvent]="eventAM"
      [preloadedComments]="true"
      (sharedPostCreated)="onSharedPostCreated($event)"
      (shareCountIncremented)="onShareCountIncremented($event)"
      (commentContextMenuOpen)="openCommentContextMenu($event)"
      (threadListUnfolded)="onMobileCommentsThreadListUnfolded($event)"
    ></app-social-actions>
  </div>
</app-bottom-sheet>

<app-bottom-sheet *ngIf="!isSwipePreview && actionSheetMounted"
  #timelineActionBottomSheet
  [backdrop]="true"
  [dismissOnBackdrop]="true"
  [closeButtonLabel]="'common.close' | translate"
  [backButtonLabel]="sidebarAction === 'editComment' ? ('common.button.back' | translate) : null"
  [middleBreakHeight]="actionSheetMiddleHeight"
  (backButtonClick)="onActionSheetBack()"
  (dismissed)="onActionSheetDismissed()">
  <div class="timeline-action-sheet" *ngIf="contextMenuObject">
    <ng-container [ngTemplateOutlet]="sidebarAction === 'editComment' ? edit : defaultTemp"></ng-container>
  </div>
</app-bottom-sheet>

<ng-template #edit>
  <div #commentEditBody class="timeline-action-sheet__edit" (input)="scheduleCommentEditResize()">
    <div class="col-12 inline-flex mt-3 mb-2">
      <app-thumbnail classList="thumbnail-inline-block mr-2 " size="md" [circle]="true"
        [imgSrc]="contextMenuObject.avatar | mediaObject"></app-thumbnail>
      <div>
        {{contextMenuObject.author.username}}
        <span class="date block">{{contextMenuObject.createdAt | dateAgo}}</span>
      </div>
    </div>
    <div class="col-12 p-fluid">
      <app-social-input style="width: 100%" (submitted)="updateComment($event)" [value]="contextMenuObject.content"
        [mediaObjectAMs]="contextMenuObject.mediaObjectAMs" [imageOnly]="true" [allowEmptySubmit]="true"
        [label]="'common.write_something' | translate" [loading]="submitDisabled">
      </app-social-input>
      <app-spinner *ngIf="spinnerState"></app-spinner>
    </div>
  </div>
</ng-template>

<ng-template #defaultTemp>
  <div class="timeline-action-sheet__menu">
    <button *ngFor="let item of items" pButton type="button"
      class="p-button-text w-full justify-content-start"
      [ngClass]="item.styleClass || 'p-button-plain'"
      [icon]="item.icon" [label]="item.label"
      (click)="item.command?.({originalEvent: $event, item: item})"></button>
  </div>
</ng-template>


<p-confirmDialog #cd header="Confirmation" icon="pi pi-exclamation-triangle" [key]="'timeline'">
  <p-footer>
    <div class="flex justify-content-around">
      <button type="button" pButton icon="pi pi-times" class="p-button-danger p-button-outlined"
        [label]="'common.button.dismiss' | translate" (click)="cd.reject()">
      </button>
      <button type="button" class="p-button-outlined" pButton icon="pi pi-check"
        [label]="'common.button.proceed' | translate" (click)="cd.accept()">
      </button>
    </div>
  </p-footer>
</p-confirmDialog>
